import { HappinessIndexList } from 'components/hr-metrics/happiness-index/HappinessIndexList';
import { ACTION_TYPE } from 'constants/constant';
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { INITIAL_DATA_QUERY } from "../../../configs/hr-metrics/configTableHappinessIndexList";
import { API_HAPPINESS_INDEX } from "../../../services/apiHappinessIndex";
import { useFetch } from "../../../services/useFetch";
import {
    downloadFile,
    getAllQueryParams,
    setQueryParams
} from "../../../utils/utils";


const HappinessIndexListContainer = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_QUERY
    const [isShowToast, setIsShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const [selectedIds, setSelectedIds] = useState([])
    const [selectedDeleteId, setSelectedDeleteId] = useState(null)
    const [modal, setModal] = useState({
        export: false,
        limit: false
    })
    const {data: happinessIndexList, fetching: getHappinessIndexList, isLoading} = useFetch(API_HAPPINESS_INDEX.LIST)
    const {fetching: exportHappinessIndexList} = useFetch(API_HAPPINESS_INDEX.EXPORT)
    const {fetching: deleteHappinessIndexList, isLoading: isDeleting} = useFetch(API_HAPPINESS_INDEX.DELETE_PERIOD)

    useEffect(() => {
        getHappinessIndexList({...query})
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({...query, ...queryParams})
        setSearchParams(params, {replace: true})
    }

    const clearToast = () => {
        setIsShowToast(false)
        setToastMessage('')
    }

    const showToast = (message) => {
        setIsShowToast(true)
        setToastMessage(message)
    }

    const setShowModal = (value) => {
        setModal({...modal, ...value})
    }

    const onClickItemHandler = ({item, actionType}) => {
        switch (actionType) {
            case ACTION_TYPE.DETAIL:
                if (item.status === 'submitted') {
                    navigate(`/human-resource-metrics/employee-happiness-index/detail-happiness-index?periodId=${item?.id}`)
                } else {
                    navigate(`/human-resource-metrics/create-happiness-index/import-data?periodId=${item?.id}`)
                }
                break;
            case ACTION_TYPE.DELETE:
                setSelectedDeleteId(item?.id)
                setShowModal({delete: true})
                break;
            default:
                break;
        }
    }

    const onExportHandler = () => {
        const { page, limit, ...payload } = query
        const body = {...payload, period_ids: selectedIds.map(item => item.id )}
    
        exportHappinessIndexList(body, '', {}, 'blob')
            .then(res => {
                downloadFile(null, res, `Happiness-Index-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
                setShowModal({export: false})
                showToast('Export Data Berhasil !!')
            })
    }

    const onDelete = () => {
        deleteHappinessIndexList(null, selectedDeleteId)
            .then(() => {
                setModal({...modal, delete: false})
                showToast('Period Happiness Index Deleted !!')
                getHappinessIndexList({...query})
            })
    }

    const props = {
        dataList: happinessIndexList?.data,
        isLoading,
        isDeleting,
        query,
        navigate,
        toast: {
            isShowToast,
            message: toastMessage
        },
        modal,
        selectedIds,
        setShowModal,
        setSelectedIds,
        clearToast,
        onChangeQuery,
        onClickItemHandler,
        onExportHandler,
        onDelete,
    }

    return <HappinessIndexList {...props} />
}

export default HappinessIndexListContainer
